<template>
  <div class="c-comment-create">
    <div class="comment-create">
      <div class="headers">
        <h3>Оставить отзыв:</h3>
        <h3 @click="closeModal">X</h3>
      </div>
      <div class="top-part">
        <div class="left-part">
          <div class="image-place">
            <img :src="$app.auth.user().avatar?$app.auth.user().avatar:imgUserAvatar" alt="">
          </div>
          <div class="user-info">
            <p>{{ $app.auth.user().fullName }}</p>
          </div>
        </div>
        <div class="right-part">
          <c-stars :star-count.sync="starCount" :is-disabled="false" />
        </div>
      </div>
      <div class="input-place">
        <n-input v-model="commentText" type="text" placeholder="Введите комментарий" class="comment-input"></n-input>
        <n-button class="comment-button" @click="createComment"> > </n-button>
      </div>
    </div>
  </div>
</template>

<script>

import imgUserAvatar from 'assets/avatar/alt-avatar.svg'
export default {
  name: 'CCommentCreate',
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      commentText: '',
      starCount: 0,
      imgUserAvatar,
    }
  },
  watch: {},
  created() {
  },
  methods: {
    createComment() {
      $api.comments.create(this.productId, {
        content: this.commentText,
        stars: this.starCount,
      }).then(() => {
        this.closeModal()
      })
    },
    closeModal() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-comment-create {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, .2);
  z-index: 100000;
  .comment-create {
    background-color: #ffffff;
    margin-bottom: 30px;
    width: 350px;
    height: 200px;
    padding: 20px;
    border-radius: 25px;
    .image-place {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .headers {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        font-size: 1.3em;
        margin-bottom: 10px;
      }
    }
    .top-part {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      justify-content: space-between;
      .left-part {
        display: flex;
        align-items: center;
        p {
          margin-left: 10px;
        }
      }
    }

    .input-place {
      display: flex;
      align-items: center;
      .comment-input {
        width: 75vw;
      }
      .comment-button {
        margin-left: 10px;
        background-color: var(--secondary);
        height: 45px;
      }
    }
  }
}
</style>
